import React from 'react';
import { Modal, Button, Segment, Dimmer, Loader } from 'semantic-ui-react';
import ErrorMessage from "../common/ErrorMessage";
import { useIntl } from "react-intl";

interface ModConfirmProps {
 open?: boolean;
 size?: string;
 titleName?: string | Record<string,any>;
 titleColor?: string;
 alertText?: string | Record<string,any>;
 buttonLeft?: string | Record<string,any>;
 buttonLeftColor?: string;
 onButtonLeftClick?: () => void;
 buttonRight?: string | Record<string,any>;
 buttonRightColor?: string;
 onButtonRightClick?: () => void;
}

const DEFAULT_PROPS = {
  open: false,
  size: "mini",
  titleName: "แจ้งเตือน",
  titleColor: "blue",
  alertText: "",
  buttonLeft: "ยกเลิก",
  buttonLeftColor: "grey",
  onButtonLeftClick: () => {},
  buttonRight: "ตกลง",
  buttonRightColor: "blue",
  onButtonRightClick: () => {},
  buttonLeftLoading: false,
  buttonRightLoading: false,
  loading: false,
  error: null,
}

const ModConfirm = (propsParam: ModConfirmProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  const intl = useIntl();

  const handleButtonLeftClick = () => {
    props.onButtonLeftClick();
  }

  const handleButtonRightClick = () => {
    props.onButtonRightClick();
  }

  return (
    <Modal
      open={props.open}
      size={props.size}
    >
      <Segment inverted className={"modHeader " + props.titleColor} style={styles.header}>
        {props.titleName}
      </Segment>
      <Dimmer.Dimmable dimmed={props.loading} style={{height: "100%"}} >
        <Dimmer active={props.loading} inverted>
          <Loader inverted />
        </Dimmer>
      <Segment padded align="center" className="modContent">
        <ErrorMessage error={props.error}/>
        <div>{props.alertText}</div>
        <div style={{ marginTop: 20 }}>
          <Button  
            loading={props.buttonLeftLoading} 
            disabled={props.buttonRightLoading}
            color={props.buttonLeftColor} 
            onClick={handleButtonLeftClick}>
            {props.buttonLeft}
          </Button>
          <Button 
            loading={props.buttonRightLoading} 
            disabled={props.buttonLeftLoading}
            color={props.buttonRightColor} 
            onClick={handleButtonRightClick}>
            {props.buttonRight}
          </Button>
        </div>
      </Segment>
      </Dimmer.Dimmable>
    </Modal >
  )
} 

const styles = {
  header: {
    lineHeight: "1.3em"
  },
  button: {
    marginTop: "10px"
  }
};


export default ModConfirm;